import classNames from 'classnames';
import { useState } from 'react';
import Icon from '../Icon';

interface Props {
  id?: string;
  name?: string;
  acceptFiles?: string;
  placeholder: string;
  status?: 'error' | 'success';
  errorMsg?: string;
}

function InputFile({
  id = '',
  name = '',
  acceptFiles,
  placeholder = '',
  status,
  errorMsg
}: Props) {
  const [fileName, setFileName] = useState<string | null>(
    null
  );

  const handleChange = (e: React.BaseSyntheticEvent) => {
    if (e.target?.files.length !== 0) {
      setFileName(e.target?.files[0].name);
    } else {
      setFileName(null);
    }
  };
  return (
    <div
      className={classNames([
        'relative flex h-[48px] w-full items-center rounded-xl border-2 py-1 pl-4 pr-1 font-circular text-sm font-medium !leading-tight !outline-none transition-colors duration-300 focus:ring-0 md:h-[52px] md:text-lg',
        !status &&
          'border-sl-blue border-opacity-25 text-sl-blue text-opacity-50',
        status === 'success' &&
          'border-sl-green text-sl-green text-opacity-100',
        status === 'error' &&
          'border-sl-red border-opacity-100 text-sl-red text-opacity-100'
      ])}
    >
      <span className="mr-2 block truncate whitespace-nowrap">
        {!fileName && <span>{placeholder}</span>}
        {fileName && <span>{fileName}</span>}
      </span>
      <div className="peer relative z-[2] ml-auto mr-[2px] p-2 text-lg !leading-none">
        <Icon
          icon="paper-clip"
          className={`${
            !status || status === 'success'
              ? 'block'
              : 'hidden'
          }`}
        />
        <Icon
          icon="circle-info"
          className={`${
            status === 'error' ? 'block' : 'hidden'
          }`}
        />
      </div>
      {errorMsg && status === 'error' && (
        <span className="invisible absolute bottom-full right-0 -mr-[2px] -mb-[6px] max-w-full rounded-lg border border-sl-red border-opacity-20 bg-[#f9e8e8] px-2 py-1 text-left font-sans text-xs font-normal text-sl-red peer-hover:visible">
          <span>{errorMsg}</span>
          <span className="absolute right-5 -bottom-1 h-2 w-2 rotate-[135deg] border-t border-r border-sl-red border-opacity-20 bg-[#f9e8e8]" />
        </span>
      )}
      <input
        onChange={handleChange}
        type="file"
        name={name}
        id={id}
        accept={acceptFiles}
        className="absolute inset-0 z-[1] opacity-0"
      />
    </div>
  );
}

export default InputFile;
